import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { getLocalStorage } from './libs/storage'

import User from './pages/user/router'
import Examination from './pages/examination/router'
import Certification from './pages/certification/router'

const sideView = () => import(/* webpackChunkName: "side" */'./pages/user/views/user')

Vue.use(Router)
const router = new Router({
  routes: [
    ...User,
    ...Examination(sideView),
    ...Certification
  ]
})

router.beforeEach((to, from, next) => {
  const toLoginPage = to.name === 'userLogin'
  const authorizeValid = getLocalStorage('exam_token') && getLocalStorage('exam_expiration') > Date.now()
  if (!toLoginPage && !authorizeValid) {
    // window.toast.error('登录失效，请重新登录')
    next({
      name: 'userLogin',
      replace: true
    })
    return
  }
  // if (toLoginPage && authorizeValid) {
  //   next({
  //     name: 'index',
  //     replace: true
  //   })
  // }
  next()
})
router.afterEach(to => {
  store.commit('setTitle', {
    title: to.meta.title || '',
    showTitle: to.meta.showTitle
  })
})

export default router
